package navigation.home.settings

import androidx.compose.runtime.Composable
import cafe.adriel.voyager.core.screen.Screen
import ui.settings.screens.BackofficeSettingsScreen

class BackofficeSettingsScreenNav(
    private val onRefresh: (() -> Unit) -> Unit,
) : Screen {
    @Composable
    override fun Content() {
        BackofficeSettingsScreen(
            onRefresh = onRefresh,
        )
    }
}